import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormControl } from "@angular/forms";
import { FieldType, FormlyFieldConfig } from "@ngx-formly/core";
import { ReplaySubject, Subject } from "rxjs";
import { debounceTime, finalize, map, takeUntil } from "rxjs/operators";
import { ApiSelectSearchService } from "../api-select-search.service";

@Component({
    selector: "formly-field-api-select-search",
    templateUrl: "formly-api-select-search.component.html",
    encapsulation: ViewEncapsulation.None,
    providers: [ApiSelectSearchService],
})
export class FormlyApiSelectSearchComponent extends FieldType implements OnInit, OnDestroy {
    private _unsubscribeAll = new Subject();

    datasource = [];

    filteredDataSource$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

    loading$ = new Subject<boolean>();

    filterCtrl: FormControl = new FormControl();

    selectCtrl: FormControl = new FormControl();

    private _url: string;

    constructor(private _service: ApiSelectSearchService) {
        super();
    }

    ngOnInit(): void {
        this._url = this.field?.templateOptions.url;

        this.filterCtrl.valueChanges
            .pipe(
                debounceTime(200),
                takeUntil(this._unsubscribeAll),
                map((keyword) => {
                    return this.datasource.filter((item) => item?.name?.toLowerCase().includes(keyword.toLowerCase()));
                })
            )
            .subscribe((items) => {
                this.filteredDataSource$.next(items);
            });

        this.selectCtrl.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
            this.formControl.setValue({
                id: value.id,
                fullName: value.name,
            });

            this.filterCtrl.setValue("");
        });

        this.fetch();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    fetch() {
        this.loading$.next(true);
        this._service
            .fetch(this._url)
            .pipe(finalize(() => this.loading$.next(false)))
            .subscribe({
                next: (result) => {
                    this.datasource = result;
                    if (this.datasource && this.datasource.length > 0 && this.formControl.value) {
                        const selectedValue = this.datasource.find((item) => item.id === this.formControl.value.id);
                        if (selectedValue) {
                            this.selectCtrl.setValue(selectedValue);
                        } else {
                            this.selectCtrl.setValue(null);
                        }
                    }
                },
                error: (error) => {
                    this.datasource = [];
                },
            });
    }

    isDisabled() {
        return this.field.templateOptions.disabled;
    }

    isValid(field: FormlyFieldConfig) {
        if (field.key) {
            return field.formControl.valid;
        }
        return field.fieldGroup ? field.fieldGroup.every((f) => this.isValid(f)) : true;
    }

    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
}
